module.exports = __webpack_public_path__ + "static/media/Fast.62d4e4a4.webp";